import React from "react";
import { store } from "static";
import "./ZCInput.css";
import { Box, InputBase } from "@mui/material";

interface IInputProps {
  cssp?: string;
  sendBtn?: () => JSX.Element;
  disabled?: boolean;
  _onSend?: (text: { text: string }) => void;
  pressEnterToSend?: boolean;
  value?: string;
}

enum InputPlaceholders {
  EN = "Type a message...",
  TC = "輸入訊息...",
  SC = "输入讯息...",
}

function ZCInput(props: IInputProps) {
  const [input, setInput] = React.useState("");
  const defaultLang = store.sysInfo.Language.default ?? "EN";
  const inputPlaceHolder = InputPlaceholders[defaultLang as keyof typeof InputPlaceholders];

  React.useEffect(() => {
    if (props.value) {
      console.log(props.value);
      if (props?._onSend) props._onSend({ text: decorateInput(input) });
    }
  }, []);

  const inputBaseComponent = React.useRef<HTMLInputElement>(null);

  const decorateInput = (input?: string): string => input?.trim().replace(/[\r\n]+/g, " ") || "";

  const sendMessage = ({ text }: { text?: string }) => {
    if (props?._onSend) props._onSend({ text: input });
  };

  const onKeyDown = (e: any) => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      sendMessage({ text: input });
      e.preventDefault();
      setInput("");
    }
  };

  const _onInputChange = () => {
    if (inputBaseComponent) {
      setInput((prev) => inputBaseComponent?.current?.value || "");
    }
    // setInput((prev) => input);
  };

  const { cssp, sendBtn } = props;

  const renderInputBox = () => {
    return (
      <Box className={cssp + " inputbox"}>
        <Box className={cssp + " inputfield " + defaultLang}>
          <InputBase
            sx={{ width: "100%" }}
            fullWidth
            id="message-input-field"
            multiline
            onKeyDown={(e) => onKeyDown(e)}
            onChange={(e) => _onInputChange()}
            placeholder={inputPlaceHolder}
            value={input || ""}
            disabled={props.disabled}
            onInput={(e) => e.target}
            inputRef={inputBaseComponent}
            readOnly={false}
          />
        </Box>
        <Box
          className={cssp + " inputsend"}
          onClick={() => {
            sendMessage({ text: input });
            setInput("");
          }}
        >
          {sendBtn ? sendBtn() : <SendButton />}
        </Box>
      </Box>
    );
  };

  return <Box className={cssp + " input"}>{renderInputBox()}</Box>;
}

function SendButton(props: { onClick?: () => void } = {}) {
  return <i className="fas fa-paper-plane" />;
}

export default ZCInput;
